import { Control, FieldValues, Path, useController } from 'react-hook-form';

import { ControlsButton } from '@/components/Controls';
import Text from '@/components/Text';

import {
  EytvSwitchRow as PasteFileSetting,
  StyledControls,
} from './EytvProperties';

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
}

const PasteFileNameField = <T extends FieldValues>({
  control,
  name,
}: Props<T>) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  return (
    <div>
      <Text $type="smallBold">Paste File Name</Text>
      <PasteFileSetting>
        <Text $type="smallNormal" $color="gray">
          Automatically apply file name of every uploaded thumbnail to the
          variation name input field
        </Text>
        <StyledControls>
          <ControlsButton
            type="button"
            active={value}
            onClick={() => {
              onChange(true);
            }}
          >
            On
          </ControlsButton>
          <ControlsButton
            type="button"
            active={!value}
            gray
            onClick={() => {
              onChange(false);
            }}
          >
            Off
          </ControlsButton>
        </StyledControls>
      </PasteFileSetting>
    </div>
  );
};

export default PasteFileNameField;
